import type { HelpFile } from '../../types/help'
import { BrandThemeToggleTestIds } from '../../../testids/BrandThemeToggleTestIds'

export const brandThemeToggleHelp: HelpFile = {
  texts: {
    [BrandThemeToggleTestIds.btnBrandTheme]: null,
  },
}
